<template>
  <ProtocolPage :title="pageTitle" :content="pageData" />
</template>

<script>
import ProtocolPage from '@/components/ProtocolPage'
import { lang } from '@/locales'

import { enData } from './enData.js'
import { esData } from './esData.js'
import { plData } from './plData.js'
import { ptData } from './ptData.js'

const dataMap = { en: enData, es: esData, pl: plData, pt: ptData }
const titleMap = {
  en: 'Terms and Conditions',
  es: 'Terms and Conditions',
  pl: 'Warunki korzystania',
  pt: 'Termos e Condições'
}

export default {
  name: 'TermsAndConditions',
  components: {
    ProtocolPage
  },
  computed: {
    pageData() {
      return dataMap[lang] || enData
    },
    pageTitle() {
      return titleMap[lang] || titleMap.en
    }
  }
}
</script>
